import Auth from '@/utils/auth';
import { MessageBox } from 'element-ui';
import { userInfo } from '@/stores/userInfo';

export function checkLogin(checkPurview = false) {
  return new Promise((resolve, reject) => {
    if (Auth.getToken()) {
      // if (checkPurview) {
      //   const userStore = userInfo();
      //   if ([1, 5].indexOf(userStore.userIdentity) == -1) {
      //     confirmPurview();
      //   } else {
      //     resolve({});
      //   }
      // } else {
      //   resolve({});
      // }
      resolve({});
    } else {
      confirmLogin();
    }
  });
}
export function confirmLogin() {
  return MessageBox.confirm('需要登录之后才能继续操作，是否登录?', '提示', {
    confirmButtonText: '前往登录',
    cancelButtonText: '先看看',
    type: 'warning',
  })
    .then(() => {
      useRouter().push('/login');
    })
    .catch();
}

export function confirmPurview() {
  return MessageBox.confirm('需要进行企业认证之后才能继续操作，是否前往企业认证?', '提示', {
    confirmButtonText: '前往认证',
    cancelButtonText: '先看看',
    type: 'warning',
  })
    .then(() => {
      useRouter().push('/usercenter/businessmanagement');
    })
    .catch();
}
